<template>
  <div :style="cssVars">
    <page-layout :noSideBar="false" headerBackgroundColor="rgb(22, 44, 71)">
      <template v-slot:headerContent>
        <div class="row">
          <span :style="`color: white`" class="title">
            {{
              currentUserData.sustainabilityBusiness_name
                ? currentUserData.sustainabilityBusiness_name
                : "Test Business"
            }}
          </span>
        </div>
        <div class="row">
          <span class="headerText text-white">
            Viewing plans for {{ $moment().format("YYYY") }}
          </span>
          <!-- <sustainability-dropdown
            :model="outcome"
            class="q-ml-sm"
            :style="`width: 230px;
                      background-color: rgba(0,0, 0, 0.3);
                      border-radius: 5px;
                      `"
            :options="outcomesList"
            :isObjects="true"
            objectKey="label"
            @input="selectOutcome"
          ></sustainability-dropdown> -->
        </div>
      </template>
      <template v-slot:content>
        <q-scroll-area
          style="height: calc(100vh - 170px)"
          :thumb-style="{
            background: '#162c479c',
            opacity: 1,
            width: '8px',
            height: '8px',
            borderRadius: '20px',
          }"
        >
          <div class="column content q-px-md q-pt-md">
            <div class="col-auto q-pa-sm">
              <h4>Your Sustainability Plans</h4>
            </div>
            <div class="col q-pa-md">
              <div class="row q-col-gutter-md justify-center">
                <div class="col-auto">
                  <q-card
                    class="planCard q-pa-sm cursor-pointer"
                    flat
                    :style="`background: #7979795F`"
                    @click="$router.push('/outcomePlans')"
                  >
                    <div class="row">
                      <div class="col-auto">
                        <div style="width: 137px">
                          <q-card
                            class="outcomeCard"
                            flat
                            :style="`background: #797979`"
                          >
                            <div class="row items-center full-height">
                              <div class="col-12 text-center text-white">
                                <q-icon
                                  name="mdi-format-list-checks"
                                  size="60px"
                                  color="white"
                                ></q-icon>
                              </div>
                            </div>
                          </q-card>

                          <p
                            class="q-mb-none q-px-sm outcomeName q-mt-sm"
                            :style="`color: #797979`"
                          >
                            Create a Plan
                          </p>
                        </div>
                      </div>
                      <div class="col"></div>
                    </div>
                  </q-card>
                </div>
                <div
                  class="col-auto"
                  v-for="(plan, index) in outcomePlansList"
                  :key="`plan_${index}`"
                >
                  <q-card
                    class="planCard q-pa-sm"
                    flat
                    :style="`background: ${plan.primaryColor}5F`"
                  >
                    <div class="row">
                      <div class="col-auto">
                        <div style="width: 137px">
                          <q-card
                            class="outcomeCard"
                            flat
                            :style="`background: ${plan.secondaryColor}`"
                          >
                            <div class="row items-center full-height">
                              <div class="col-12 text-center text-white">
                                <q-img
                                  :src="getWhiteOutcomeImage(plan)"
                                  class="planOutcomeImage q-mb-xs"
                                ></q-img>
                              </div>
                            </div>
                          </q-card>

                          <p
                            class="q-mb-none q-px-sm outcomeName q-mt-sm"
                            :style="`color: ${plan.secondaryColor}`"
                          >
                            {{ plan.label }}
                          </p>
                        </div>
                      </div>
                      <div class="col q-px-sm q-pt-lg">
                        <q-btn-dropdown
                          flat
                          no-caps
                          class="full-width"
                          :style="`background: ${plan.tertiaryColor}`"
                          label="View"
                        >
                          <q-list>
                            <q-item
                              clickable
                              @click="$router.push(`/fullPlan/${plan.id}`)"
                              v-close-popup
                            >
                              <q-item-section>
                                <q-item-label>Internal</q-item-label>
                              </q-item-section>
                            </q-item>

                            <q-item clickable v-close-popup :disable="true">
                              <q-item-section>
                                <q-item-label>Live (Coming Soon)</q-item-label>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-btn-dropdown>
                        <q-btn-dropdown
                          flat
                          class="full-width q-mt-sm"
                          no-caps
                          :style="`background: ${plan.tertiaryColor}`"
                          label="Share"
                        >
                          <q-list>
                            <q-item clickable v-close-popup :disable="true">
                              <q-item-section>
                                <q-item-label>
                                  Live Link (Coming Soon)
                                </q-item-label>
                              </q-item-section>
                            </q-item>
                          </q-list>
                        </q-btn-dropdown>
                        <!-- <q-btn
                          flat
                          class="full-width q-mt-sm"
                          no-caps
                          :style="`background: ${plan.tertiaryColor}`"
                          label="Settings"
                          @click="$router.push(`/myPlans/settings/${plan.id}`)"
                        >
                        </q-btn> -->
                      </div>
                    </div>
                  </q-card>
                  <div class="text-center">
                    <!-- <q-checkbox label="Incomplete"></q-checkbox>
                    <span class="text-grey-5 q-ml-sm">(Click to Complete)</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </template>
      <template v-slot:sideBarContent>
        <div class="column full-height full-width sidebar">
          <div class="col q-my-md q-pa-md">
            <h3>What do these do</h3>
          </div>
          <div class="col-auto q-px-md">
            <q-scroll-area
              style="height: calc(100vh - 140px)"
              :thumb-style="{
                background: '#162c479c',
                opacity: 1,
                width: '8px',
                height: '8px',
                borderRadius: '20px',
              }"
            >
              <h4>View</h4>
              <p>
                <b>Internal View</b> allows only users of your account to review
                your full plan
              </p>
              <p>
                <b>Live View</b> is a shareable plan that you can review before
                sharing. This URL can be viewed by anyone that you have given
                the link to. We also give you the ability to hide or reveal
                modules that you don’t want viewers to see
              </p>
              <h4>Share</h4>
              <p>
                <b>Get Live Link</b> Copies the shareable link of your live plan
              </p>
              <!-- <h4>Settings</h4>
              <p>
                <b>Allows</b> you to customise what modules are displayed on
                your Live Link
              </p> -->
            </q-scroll-area>
          </div>
        </div>
      </template>
    </page-layout>
    <q-dialog
      v-if="$route.params.plan_id"
      v-model="settingsDialog"
      persistent
      max-width="90vw"
    >
      <my-plans-settings-form
        @reloadData="loadData"
        ref="storyCard"
      ></my-plans-settings-form>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageLayout from "@/components/pageLayout/pageLayout.vue";
import SustainabilityDropdown from "@/components/sustainabilityDropdown/sustainabilityDropdown.vue";
import { getCSSVars } from "@/functions/cssVars";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
import MyPlansSettingsForm from "@/components/myPlans/myPlansSettingsForm.vue";

export default {
  components: {
    PageLayout,
    SustainabilityDropdown,
    MyPlansSettingsForm,
  },
  async mounted() {
    this.loadData();

    if (this.selectedOutcome) {
      this.initSelectedOutcome();
    }
  },
  data: () => ({
    outcome: null,
    settingsDialog: true,
  }),
  watch: {
    selectedOutcome: function () {
      this.initSelectedOutcome();
    },
  },
  computed: {
    ...mapGetters({
      outcomesList: "outcomes/list",
      currentUserData: "auth/currentUserData",
      outcomePlansList: "businessOutcomePlans/list",
      outcomePlansListLoading: "businessOutcomePlans/listLoading",
      outcomePlan: "businessOutcomePlans/current",
      outcomePlanLoading: "businessOutcomePlans/currentLoading",
      selectedOutcome: "businessOutcomePlans/selectedOutcome",
    }),
    cssVars() {
      let outcome = this.selectedOutcome;
      return getCSSVars(outcome);
    },
  },
  methods: {
    getCSSVars: getCSSVars,
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    loadData() {
      this.$store.dispatch("businessOutcomePlans/loadAll");
    },
    initSelectedOutcome() {
      this.outcome = this.selectedOutcome;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 1rem;
    color: $accent2;
    margin: 15px 0px;
  }

  b {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    color: $accent2;
  }
}

.content {
  h4 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 1.2rem;
    line-height: 24px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 10px 0px;
  }

  .planCard {
    width: 262px;
    height: 197px;
    border-radius: 10px;
    transition: box-shadow 250ms;

    &:hover {
      box-shadow: 0px 0px 15px 0px #c4c4c4 !important;
    }

    .outcomeCard {
      height: 137px;
      width: 137px;
      border-radius: 20px;

      .planOutcomeImage {
        height: 75px;
        width: 75px;
      }
    }
    .outcomeName {
      font-weight: 600;
      font-size: 0.9rem;
      text-align: center;
      line-height: 1.1rem;
    }
  }
}

.headerText {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
}
</style>
